import { z } from "zod";
import { partnerSchema } from "../schemas/index.js";
export class PartnersResource {
    http;
    constructor(http) {
        this.http = http;
    }
    list() {
        return this.http.request({
            method: "GET",
            path: "/partners",
            endpoint: "partners.list",
            dataSchema: z.array(partnerSchema),
        });
    }
    get(partnerId) {
        return this.http.request({
            method: "GET",
            path: `/partners/${encodeURIComponent(partnerId)}`,
            endpoint: "partners.get",
            dataSchema: partnerSchema,
        });
    }
}
//# sourceMappingURL=partners.js.map